import React, { useState } from 'react';
import { Typography, Link, Box, Snackbar, Alert } from '@mui/material';
import { AuthContainer, AuthCard, AuthTextField, AuthButton } from './styles/AuthStyles';
import CheckIcon from '@mui/icons-material/Check';

const SignUp = ({ onSignUp }) => {
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const handleSignUp = () => {
    if (!displayName || !email || !password1 || !password2) {
      setSnackbar({
        open: true,
        message: `すべてのフィールドに入力が必要です。`,
        severity: 'error',
      });
      return;
    }

    if (password1 !== password2) {
      setSnackbar({
        open: true,
        message: `パスワードが間違っています。`,
        severity: 'error',
      });
      return;
    }

    setSnackbar({
      open: true,
      message: `${email}宛にメールが送信されました。`,
      severity: 'success',
    });

    // サインアップ処理
    onSignUp(displayName, email, password1, (err) => {
      setSnackbar({
        open: true,
        message: 'アカウントの有効化に失敗しました。後ほど再度お試しください。',
        severity: 'error',
      });
    });
  };

  return (
    <AuthContainer>
      <AuthCard>
        <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
          FocusTrack
        </Typography>
        <Typography variant="h5" gutterBottom align="center">
          新規登録
        </Typography>
        <Box>
          <AuthTextField
            fullWidth
            label="名前"
            variant="outlined"
            onChange={(e) => setDisplayName(e.target.value)}
            required
          />
          <AuthTextField
            fullWidth
            label="メールアドレス"
            variant="outlined"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <AuthTextField
            fullWidth
            label="パスワード"
            variant="outlined"
            type="password"
            onChange={(e) => setPassword1(e.target.value)}
            required
          />
          <AuthTextField
            fullWidth
            label="パスワード（確認）"
            variant="outlined"
            type="password"
            onChange={(e) => setPassword2(e.target.value)}
            required
          />
          <AuthButton fullWidth onClick={handleSignUp} variant="contained" type="submit">
            アカウント作成
          </AuthButton>
        </Box>
        <Typography align="center" sx={{ mt: 2 }}>
          すでにアカウントをお持ちの方は{' '}
          <Link href="/login" underline="none" sx={{ color: '#FE6B8B' }}>
            こちら
          </Link>
        </Typography>
      </AuthCard>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          icon={<CheckIcon fontSize="inherit" />}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </AuthContainer>
  );
}

export default SignUp;